module.exports = __webpack_public_path__ + "img/SC-999.4b62d43a.png";